exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-warehousing-stocktransfer-edit-transfer th.img{width:1px}#modal-warehousing-stocktransfer-edit-transfer th.qty{width:67px}#modal-warehousing-stocktransfer-edit-transfer .input-qty{text-align:center}#modal-warehousing-stocktransfer-edit-transfer .products-thumbs{max-width:75px;max-height:75px}", ""]);

// exports
